import React from "react";
import { TableCompData } from "../../../components";
import EmptyTable from "../../../components/Common/EmptyTable";
import TablePagination from "../../../components/Table/Pagination";
import { MemberLoanStatusHeader } from "../../../utils/TableHeader";
import TableSkeletonLoader from "../../../components/Common/TableSkeletonLoader";

export default function LoanStatusTable({
  name,
  loading,
  setPageNumber,
  pagination,
  TableData,
  onViewDetails,
  onViewRepaymentPlan,
}) {
  return (
    <>
      <main>
        <div className="mb-5">
          <TableCompData
            marginBottom={"1rem"}
            columns={MemberLoanStatusHeader(onViewDetails, onViewRepaymentPlan, name)}
            data={TableData || []}
            progressPending={loading}
            progressComponent={<TableSkeletonLoader rows={10} columns={6} />}
            message={
              !loading && (
                <EmptyTable Message={`There are currently no ${name}`} />
              )
            }
            cellPadding="12px"
          />
          {!loading && TableData?.length > 0 && pagination && (
            <TablePagination
              marginTop={"0"}
              handlePageChange={setPageNumber}
              {...pagination}
            />
          )}
        </div>
      </main>
    </>
  );
}
